import { ThemeProvider as StyledComponentThemeProvider } from 'styled-components';
import { useSelector } from 'react-redux';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material';

import useParameters from '../../features/schema/useParameters';
import { THEME } from '../../theming/theme';

import {
  daDirektTheme,
  daKauflandTheme,
  dentoloTheme,
  fressnapfTheme,
  petoloTheme,
  vitoloTheme,
} from '../../theming/themes';

const getTheme = {
  [THEME.DENTOLO_THEME]: dentoloTheme,
  [THEME.PETOLO_THEME]: petoloTheme,
  [THEME.VITOLO_THEME]: vitoloTheme,
  [THEME.DA_DIREKT_THEME]: daDirektTheme,
  [THEME.DA_KAUFLAND_THEME]: daKauflandTheme,
  [THEME.FRESSNAPF_THEME]: fressnapfTheme,
  DEFAULT: dentoloTheme,
};

function GetoloThemeProvider(props) {
  const { children } = props;

  const { theme: themeNameFromUrl } = useParameters();
  const themeNameFromSchema = useSelector((state) => state?.schema?.activeSchema?.SCHEMA?.theme);

  const themeName = themeNameFromUrl || themeNameFromSchema || THEME.DENTOLO_THEME;

  const themeSystem = getTheme[`${themeName}`] || getTheme.DEFAULT;

  const muiTheme = createTheme({ ...themeSystem, tyrionTheme: themeName });
  const styledTheme = { ...themeSystem, theme: themeName };

  return (
    <MUIThemeProvider theme={muiTheme}>
      <StyledComponentThemeProvider theme={styledTheme}>{children}</StyledComponentThemeProvider>
    </MUIThemeProvider>
  );
}

export default GetoloThemeProvider;
